import { DOCUMENT, inject, Injectable } from '@angular/core';

import { INavigator, NAVIGATOR, UaParserService, WINDOW } from '@hglobal/fin-ui';

import { GlobalDialogService } from '@zeusm/shared/core/services';

import { PwaSetupComponent } from './pwa-setup.component';
import { IS_PWA_INSTALLED } from './pwa-setup.entities';

@Injectable({ providedIn: 'root' })
export class PwaSetupDialog {
  readonly #navigator = inject<INavigator>(NAVIGATOR);

  readonly #dialogService = inject(GlobalDialogService);
  readonly #uaParser = inject(UaParserService);
  readonly #document = inject(DOCUMENT);
  readonly #window = inject(WINDOW);
  readonly #isPwaInstalled: boolean = JSON.parse(localStorage.getItem(IS_PWA_INSTALLED) || 'false');

  init(): void {
    if (this.#shouldShowPwaSetupDialog()) {
      this.#openPwaSetupDialog();
    }
  }

  checkOldIos(): boolean {
    const userAgent = this.#window.navigator.userAgent;
    const match = userAgent.match(/OS (\d+)_\d+/);
    return match ? Number.parseInt(match[1], 10) <= 12 : false;
  }

  #isStandaloneMode(): boolean {
    const isStandalone = this.#window.matchMedia('(display-mode: standalone)').matches;
    const isNavigatorStandalone = this.#navigator.standalone;
    const isAppReferrer = ['android-app://', 'ios-app://'].some(app => this.#document.referrer.includes(app));

    return isStandalone || isNavigatorStandalone || isAppReferrer;
  }

  #shouldShowPwaSetupDialog(): boolean {
    const isMobileDevice = this.#uaParser.isMobile;
    return !this.#isStandaloneMode() && isMobileDevice && !this.#isPwaInstalled && location.href.includes('signin');
  }

  #openPwaSetupDialog(): void {
    this.#dialogService.open({
      components: [PwaSetupComponent],
    });
  }
}
